var map = {
	"./1.png": "c1c5",
	"./2.png": "81e5",
	"./3.png": "619a",
	"./4.png": "33b2",
	"./Asset 15.png": "252f",
	"./Banner Mobile_21.png": "ae1c",
	"./Banner Mobile_22.png": "296b",
	"./Banner Mobile_61.png": "aa87",
	"./Banner Mobile_62.png": "ef22",
	"./Banner Mobile_HTS.png": "48e4",
	"./Banner Mobile_TH.png": "96af",
	"./Banner_CTST2.png": "cac7",
	"./Banner_CTST6.png": "e848",
	"./Banner_HTS.png": "ac51",
	"./Banner_KNTT2.png": "6e79",
	"./Banner_KNTT6.png": "feb1",
	"./CompositeLayer.png": "472c",
	"./HS-2.jpg": "3fbf",
	"./Logo 2.png": "6ad32",
	"./RemovePrefix.bat": "9660",
	"./active-2.png": "cfe8",
	"./active.png": "5e9f",
	"./alert.png": "55f2",
	"./audio.png": "0361",
	"./banner-book.png": "0dd7",
	"./banner.png": "1936",
	"./bg-book-1.png": "c06a",
	"./bg-book-2.png": "13b7",
	"./bg-home-hts.png": "a1fb",
	"./bg-number.png": "f853",
	"./bg_home.png": "841a",
	"./bg_intro.png": "323b",
	"./blank.svg": "ba14",
	"./book-icon.png": "7bb8",
	"./book/Logo 3 BW.png": "43b5",
	"./book/Logo 4 BW.png": "0a93",
	"./book/banner_sdt.jpg": "7aa1",
	"./book/book_type_1.png": "4b8a",
	"./book/book_type_2.png": "df94",
	"./book/book_type_3.png": "01e1",
	"./book/book_type_4.png": "472f",
	"./box1.png": "0717",
	"./checked.png": "4f4e",
	"./class-icon.png": "e14e",
	"./copper.svg": "ef07",
	"./document1.png": "b01b",
	"./down.png": "7c7c",
	"./down2.png": "7ed4",
	"./down3.png": "21ac",
	"./ebook-exercise.svg": "d30a",
	"./ebook-lesson.svg": "b39d",
	"./ebook.png": "cc40",
	"./fx.png": "50cc",
	"./gif.png": "201a",
	"./gold.svg": "d87b",
	"./home-bg.png": "dddb",
	"./home-bg_old.png": "6377",
	"./home-training-new.png": "2828",
	"./home-training.png": "33dd",
	"./icon-close.png": "6891",
	"./iconfb.png": "8a7a",
	"./icongg.png": "52b5",
	"./image.png": "bf05",
	"./imagehoclieu.png": "8814",
	"./img-detail.png": "4604",
	"./img_404.jpg": "700c",
	"./laptop-hts.png": "62c2",
	"./link.png": "6ad3",
	"./linktypes/3d-2.svg": "f7a9",
	"./linktypes/3d-3.svg": "e780",
	"./linktypes/3d.svg": "15e5",
	"./linktypes/audio-2.svg": "7eb5",
	"./linktypes/audio-3.svg": "ec93",
	"./linktypes/audio.svg": "dbdd",
	"./linktypes/audioresize40.svg": "09fb",
	"./linktypes/done.svg": "3878",
	"./linktypes/gif-2.svg": "b334",
	"./linktypes/gif-3.svg": "ba3b",
	"./linktypes/gif.svg": "2b2d",
	"./linktypes/image-2.svg": "f480",
	"./linktypes/image-3.svg": "7cfb",
	"./linktypes/image.svg": "d19f",
	"./linktypes/nhom-hoc-lieu-2.svg": "f211",
	"./linktypes/nhom-hoc-lieu-3.svg": "11bc",
	"./linktypes/nhom-hoc-lieu.svg": "134e",
	"./linktypes/pause.svg": "308f",
	"./linktypes/play-2.svg": "697b",
	"./linktypes/play-3.svg": "bb01",
	"./linktypes/play.svg": "58d3",
	"./linktypes/playresize.svg": "29ce",
	"./loading.gif": "12ae",
	"./loading.svg": "afd7",
	"./logo - Copy (2).png": "2f81",
	"./logo - Copy.png": "be6b",
	"./logo-footer.png": "6331",
	"./logo-footer2.png": "3be0",
	"./logo-hts-footer.png": "09f3",
	"./logo-hts.png": "d8ac",
	"./logo-nxb.png": "87c6",
	"./logo.png": "9d64",
	"./logo4dots.png": "526e",
	"./logo_hts.png": "916f",
	"./logo_hts_1.png": "c87d",
	"./lop10/slide1.jpg": "f091",
	"./lop10/slide2.jpg": "838e",
	"./lop3/slide1.jpg": "0bb3",
	"./lop3/slide2.jpg": "1f2f",
	"./lop7/slide1.jpg": "e79a",
	"./lop7/slide2.jpg": "4044",
	"./menu-icon.png": "06bf",
	"./nav-icon.png": "f3cd",
	"./next.png": "0f66",
	"./one-page.png": "3959",
	"./pdf.png": "b9de",
	"./pen.png": "0fae",
	"./pencil-icon.png": "6e4a",
	"./pencil.png": "c2d1",
	"./play.png": "c4bf",
	"./playsuggest.png": "ae61",
	"./power.png": "c3c1",
	"./prev.png": "b1d2",
	"./question-icon.png": "993c",
	"./search.png": "1b61",
	"./searchhoclieu.png": "dfc4",
	"./silver.svg": "bdf4",
	"./style-question/concat-1.jpg": "1d69",
	"./style-question/concat-2.jpg": "1644",
	"./style-question/fill-blank-1.jpg": "1bc7",
	"./style-question/fill-blank-2.jpg": "dd13",
	"./style-question/fill-blank-3.jpg": "2e94",
	"./style-question/fill-blank-4.jpg": "5815",
	"./style-question/fill-blank-5.jpg": "5956",
	"./style-question/fill-input-1.jpg": "38ad",
	"./style-question/fill-input-2.jpg": "9c79",
	"./style-question/fill-input/circle the correct answer 2 column.JPG": "399f",
	"./style-question/fill-input/fill input 1 row.JPG": "8018",
	"./style-question/fill-input/fill-input-1.JPG": "0f70",
	"./style-question/fill-input/fill-input-2.JPG": "64ef",
	"./style-question/fill-input/radio 1 row.JPG": "5f05",
	"./style-question/fill-input/radio2 column.JPG": "841f",
	"./style-question/radio-1.jpg": "02cf",
	"./style-question/radio-2.jpg": "6821a",
	"./style-question/select-box-1.jpg": "13e9f",
	"./style-question/tf-1.jpg": "aef7",
	"./style-question/tf-2.jpg": "86ae",
	"./thumb-audio.png": "dd66",
	"./tick-error.png": "ada7",
	"./tick.png": "4b11",
	"./two-page.png": "59e0",
	"./under-construction.png": "a08f",
	"./unknow.png": "b417",
	"./unknow2.png": "bc79",
	"./user-avatar.png": "fa37",
	"./user-mark.png": "691e",
	"./user.png": "ba97",
	"./video.png": "c59e",
	"./word.png": "dccb",
	"./x-mark-error.png": "46db",
	"./x-mark.png": "3d11",
	"./youtobe.png": "c19d",
	"./zoom-in.png": "8f13",
	"./zoom-out.png": "328d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";